import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa203db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CartNormal_Top" }
const _hoisted_2 = { class: "CartNormal_TopWrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CartNormal_TopWrapper_Title" }, "書店・取次情報入力", -1))
const _hoisted_4 = { class: "CartNormal_TopWrapper_Container" }
const _hoisted_5 = { class: "CartNormal_TopWrapper_Content" }
const _hoisted_6 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_7 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "取次コード", -1))
const _hoisted_9 = { class: "CartNormal_ListContent_Large" }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_13 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "書店", -1))
const _hoisted_15 = { class: "CartNormal_ListContent_Large" }
const _hoisted_16 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_17 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "番線/作業コード", -1))
const _hoisted_19 = { class: "CartNormal_ListContent_Large" }
const _hoisted_20 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_21 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "取引条件", -1))
const _hoisted_23 = { class: "CartNormal_ListContent_Large" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "CartNormal_TopWrapper_ListItem"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "期間", -1))
const _hoisted_27 = { class: "CartNormal_ListContent" }
const _hoisted_28 = {
  key: 0,
  class: "CartNormal_ListContent_Error"
}
const _hoisted_29 = { class: "CartNormal_TopWrapper_Content" }
const _hoisted_30 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_31 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "短冊メモ", -1))
const _hoisted_33 = { class: "CartNormal_ListContent_Large" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CartNormal_ListContent_Error" }, "※「短冊メモ」は全角16文字以内で入力してください", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_38 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "伝票備考", -1))
const _hoisted_40 = { class: "CartNormal_ListContent_Large" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CartNormal_ListContent_Error" }, "※「伝票備考」は全角30文字以内で入力してください", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_45 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "営業担当者", -1))
const _hoisted_47 = { class: "CartNormal_ListContent_Large" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "CartNormal_TopWrapper_List" }
const _hoisted_50 = { class: "CartNormal_TopWrapper_ListItem" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CartNormal_ListTitle" }, "社内備考", -1))
const _hoisted_52 = { class: "CartNormal_ListContent_Large" }
const _hoisted_53 = { class: "delete_btn" }
const _hoisted_54 = { class: "CartNormal_Bottom" }
const _hoisted_55 = { class: "CartNormal_Bottom_Wrapper" }
const _hoisted_56 = { class: "CartNormal_Bottom_WrapperSelect" }
const _hoisted_57 = { class: "CartNormal_Bottom_WrapperSelect" }
const _hoisted_58 = { class: "btn_group" }
const _hoisted_59 = {
  key: 0,
  class: "CartNormal_Badge"
}
const _hoisted_60 = { class: "btn_group" }
const _hoisted_61 = { class: "btn_group" }
const _hoisted_62 = { class: "CartNormal_Bottom_WrapperTable" }
const _hoisted_63 = {
  key: 0,
  class: "CartNormal_FrameTable"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB" }
const _hoisted_70 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB Text_Left" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = {
  class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB Text_Left",
  style: {"width":"800px"}
}
const _hoisted_77 = { style: {"width":"50px"} }
const _hoisted_78 = ["value", "onChange"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "(空白)", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "補充", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "客注", -1))
const _hoisted_82 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = { style: {"width":"50px"} }
const _hoisted_85 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB" }
const _hoisted_86 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB" }
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = { class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB Text_Left" }
const _hoisted_89 = ["onDblclick", "onFocus"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  class: "CartNormal_FrameTable_Flex CartNormal_FrameTable_Sticky_TB Text_Left",
  style: {"width":"800px"}
}
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { style: {"width":"50px"} }
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "(空白)", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "補充", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "客注", -1))
const _hoisted_100 = [
  _hoisted_97,
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = ["onUpdate:modelValue"]
const _hoisted_102 = { style: {"width":"50px"} }
const _hoisted_103 = { class: "CartNormal_Bottom_WrapperRegister" }
const _hoisted_104 = {
  key: 5,
  class: "CartNormal_Bottom CartNormal_Bottom_Message"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "※カートに製品がありません", -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = ["value"]

import {
  ref,
  reactive,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
} from "vue";
import * as xlsx from "xlsx";
import InputText from "../components/atoms/Input/InputText.vue";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import BtnGreenSmall from "../components/atoms/button/BtnGreenSmall.vue";
import BadgeHold from "../components/atoms/Badge/BadgeHold.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import ModalShopList from "../components/modal/ModalShopList.vue";
import ModalOrderUploadTutorial from "../components/modal/ModalOrderUploadTutorial.vue";
import ModalWarningMessage from "../components/modal/ModalWarningMessage.vue";
import selectBarSingle from "../components/molecules/selectBarSingle.vue";
import SelectNormal from "../components/atoms/select/SelectNormal.vue";
import OrderFooter from "../components/OrderFooter.vue";
import ModalSyosiList from "@/components/modal/ModalSyosiList.vue";
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import axios, { AxiosResponse } from "axios";
import { useStore } from "vuex";
import {
  RouteLocationNormalized,
  onBeforeRouteLeave,
  useRouter,
} from "vue-router";
import { Notyf } from "notyf";
import { ZaikoData } from "@/types/zaiko";
import ModalConfirmCustom from "@/components/modal/ModalConfirmCustom.vue";
import common from "../common";

// ナビゲーションガード---------------------------------------------
// 未更新データがある場合、画面遷移前に確認する
interface normalItem {
  addNumber: number;
  juchuCartId: number;
  janCd: string;
  syosiCd: string;
  title: string;
  quantity: number | string;
  juchuKbn: string | null;
  hontaiPrice: number;
  hold: boolean;
  availableAmount: number; // 出荷可能数
  torioki: number; // 取置数
  inputSum: number | null; // 受注合計
  holdSum: number | null; // 保留合計
  zsId: string; // 在庫ID
  zsName: string; // 在庫ステータス
  syuppanSyosiCd: number;
  selectFlg: boolean;
  [key: string]: string | number | boolean | null;
}

interface ResOfCartData {
  addNumber: number;
  availableAmount: number;
  bansen: string;
  chumonRemarks: string;
  companyRemarks: string;
  hold: null | number;
  holdSum: null | number;
  hontaiPrice: number;
  inputSum: null | number;
  janCd: string;
  juchuCartId: number;
  juchuKbn: null | number;
  quantity: number;
  salesName: string;
  syosiCd: string;
  syotenCd: null | number | string;
  syotenMei: string;
  tanzaku: string;
  title: string;
  torihikiCd: number;
  torioki: number;
  toritugiCd: string;
  toritugiSyotenCd: string;
  userId: null | number | string; // 不明
  zsId: string;
  zaikoStatus: number;
  [key: string]: string | number | null;
}
interface HeaderInfo {
  syotenMei: string;
  syotenCd: string | number | null;
  toritugiSyotenCd: string;
  toritugiCd: string;
  bansen: string;
  tanzaku: string;
  chumonRemarks: string; //伝票備考
  salesName: string;
  companyRemarks: string;
  torihikiCd: number | string; //取引条件(取引Cd)
  torihikiKikan: string;
  [key: string]: string | number | null;
}
interface PostObj extends Omit<normalItem, "juchuKbn"> {
  juchuKbn: number | null;
}

//モーダル開閉-----------
type AddedMeisai = typeof addedMeisai.value[0];

// 新規明細追加-------------

export default /*#__PURE__*/_defineComponent({
  __name: 'CartNormal',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  setup(__props) {

let navTo: RouteLocationNormalized; // ナビゲーション先
let fromModalNav = false; // モーダルから遷移する場合はダイアログを表示させないようにするフラグ
onBeforeRouteLeave(async (to, from) => {
  // ダイアログ表示
  if (hasChangeData() && !fromModalNav) {
    navTo = to;
    showModal("modalConfirm");
    return false;
  }
});
// 追加明細に更新データがあるか確認する
const hasChangeData = () => {
  let hasData = false;
  addedMeisai.value.forEach((meisai) => {
    // 書誌情報
    if (
      !(
        meisai.janCd === null ||
        meisai.janCd === "" ||
        meisai.syosiCd === null ||
        meisai.syosiCd === "" ||
        meisai.syuppanSyosiCd === null ||
        meisai.syuppanSyosiCd === ""
      )
    ) {
      hasData = true;
    }
    // 数量
    else if (
      !(
        meisai.quantity === null ||
        meisai.quantity === "" ||
        (meisai.quantity as number) === 0
      )
    ) {
      hasData = true;
    }
  });
  return hasData;
};
const excuteSaveMeisai = async (isSave: boolean) => {
  if (isSave) {
    const saveRes = await saveMeisai();
    if (saveRes === "success") {
      fromModalNav = true;
      router.push(navTo.path);
    }
  } else {
    fromModalNav = true;
    router.push(navTo.path);
  }
};

// 初期設定----------
const props = __props;
const notyf = new Notyf();

// ストア関連
const store = useStore();
//router定義
const router = useRouter();
// 型定義------------
let modalName = ref("");
const showModal = (argModalName: string) => {
  modalName.value = argModalName;
};
const closeModal = () => {
  modalName.value = "";
};

//ぱんくずヘッダー
const currentPathList = [
  { name: "受注入力" },
  { name: "通常受注" },
  { name: "カート照会" },
];

// 全体で使用する変数---------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);
//営業担当
const salesList = store.getters["constant/getSalesList"];
//取引条件
const torihikiList = store.getters["constant/getTorihikiList"];

//テーブル表示情報----------
let headers = [
  { title: "明細No", stickyFlg: true },
  { title: "選択", stickyFlg: true },
  {
    title: "書誌CD",
    dataTitle: "syosiCd",
    titleB: "出版社書誌CD",
    dataTitleB: "syuppanSyosiCd",
    titleC: "ISBN13桁",
    dataTitleC: "janCd",
    stickyFlg: true,
    sortFlg: true,
  },
  { title: "書誌名", dataTitle: "title", stickyFlg: true, sortFlg: true },
  {
    title: "本体価格",
    dataTitle: "hontaiPrice",
    stickyFlg: false,
    sortFlg: true,
  },
  { title: "数量", stickyFlg: false },
  { title: "注文種別", stickyFlg: false, sortFlg: false },
  { title: "保留設定", stickyFlg: false, sortFlg: false },
  { title: "出荷可能数", dataTitle: "availableAmount", sortFlg: true },
  { title: "在庫ｽﾃｰﾀｽ", dataTitle: "zsName", sortFlg: true },
  { title: "取置数", dataTitle: "torioki", sortFlg: true },
  { title: "受注合計", dataTitle: "inputSum", sortFlg: true },
  { title: "保留合計", dataTitle: "holdSum", sortFlg: true },
  { title: "削除", stickyFlg: false, sortFlg: false },
];

let headerInfo: HeaderInfo = reactive({
  syotenMei: "",
  syotenCd: "",
  toritugiSyotenCd: "",
  toritugiCd: "",
  bansen: "",
  tanzaku: "",
  chumonRemarks: "", //伝票備考
  salesName: store.getters["constant/getIsSales"] ? salesList[1].salesCd : "",
  companyRemarks: "",
  torihikiCd: "1", //取引条件(取引Cd)
  torihikiKikan: "1",
});
let syosiList = ref<normalItem[]>([
  {
    addNumber: -1,
    juchuCartId: -1,
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: -1,
    juchuKbn: null,
    hontaiPrice: -1,
    hold: false,
    availableAmount: -1,
    torioki: -1,
    inputSum: null,
    holdSum: null,
    zsId: "",
    zsName: "",
    syuppanSyosiCd: -1,
    selectFlg: false,
  },
]);

//カート情報の取得
const getCartData = async () => {
  syosiList.value.splice(0);
  syosiList.value.push({
    addNumber: -1,
    juchuCartId: -1,
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: -1,
    juchuKbn: null,
    hontaiPrice: -1,
    hold: false,
    availableAmount: -1,
    torioki: -1,
    inputSum: null,
    holdSum: null,
    zsId: "",
    zsName: "",
    syuppanSyosiCd: -1,
    selectFlg: false,
  });
  try {
    let res: AxiosResponse<ResOfCartData[]>;
    // ソート時のデータ取得
    if (isSorting.value === true) {
      res = await axios.get(
        `${store.getters["getBaseUrl"]}/chumon/cartData?mode=0&order=${sortInfo.value.sortItem}&sort=${sortInfo.value.isKoujun}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
    }
    // 通常のデータ取得
    else {
      res = await axios.get(
        `${store.getters["getBaseUrl"]}/chumon/cartData?mode=0`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
    }
    // console.log(JSON.parse(JSON.stringify(res.data)));

    res.data.forEach((data: ResOfCartData, dataIndex) => {
      // 書誌データの代入
      let pushSyosi = {} as normalItem;
      Object.keys(syosiList.value[0]).forEach((syosiKey: keyof normalItem) => {
        Object.keys(data).forEach((dataKey: keyof ResOfCartData) => {
          if (syosiKey === dataKey) {
            pushSyosi[syosiKey] = data[dataKey];
          }
        });
      });
      // チェックボックス用プロパティの追加
      pushSyosi.selectFlg = false;

      syosiList.value.push(pushSyosi);
      // syosiList.value.push({
      //   ...data,
      // });

      // ヘッダー情報の代入
      if (dataIndex === 0) {
        Object.keys(data).forEach((dataKey: keyof ResOfCartData) => {
          if (headerInfo[dataKey] !== undefined && data[dataKey] !== null) {
            headerInfo[dataKey] = data[dataKey];
          }
        });
      }
    });
    syosiList.value.splice(0, 1);
  } catch (error) {
    alert("カートデータの取得に失敗しました");
    console.log(error);
  }
};
// created
const created = async () => {
  // カートデータの取得
  await getCartData();
  // created時にaddedMeisaiを空にし、もしデータがなければ明細追加する
  addedMeisai.value.splice(0);
  if (syosiList.value.length === 0 && addedMeisai.value.length === 0) {
    setInitialMeisai();
  }
};
created();

//入力ヘッダへの入力処理
const inputHederInfo = (eventValue: any, key: string) => {
  headerInfo[key] = eventValue;
};
const selecSyosiInfo = (event: Event, syosiIndex: number, key: string) => {
  syosiList.value[syosiIndex][key] = (event.target as HTMLInputElement).value;
};

//注文種別一括選択---------------------------
let selectBar_syubetu = {
  title: "注文種別一括",
  select_list: [
    { name: "補充", selectFlg: false, juchuKbn: 0 },
    { name: "客注", selectFlg: false, juchuKbn: 1 },
    { name: "(空白)", selectFlg: false, juchuKbn: null },
  ],
};
const updateSelectSyubetu = (newVal: any): void => {
  syosiList.value.forEach((item) => {
    item.juchuKbn = newVal.juchuKbn;
  });
  addedMeisai.value.forEach((meisai) => {
    meisai.juchuKbn = newVal.juchuKbn;
  });
  addHighLight("syubetu");
};

//保留設定一括選択---------------------------
let selectBar_hold = {
  title: "保留設定一括",
  select_list: [
    { name: "保留", selectFlg: false },
    { name: "保留しない", selectFlg: false },
  ],
};
const updateSelectHold = (newVal: any): void => {
  syosiList.value.forEach((item) => {
    if (newVal.name == "保留") {
      item.hold = true;
    } else {
      item.hold = false;
    }
  });
  addedMeisai.value.forEach((meisai) => {
    if (newVal.name == "保留") {
      meisai.hold = true;
    } else {
      meisai.hold = false;
    }
  });
  addHighLight("hold");
};

//一括選択処理---------------------------
let highLightTargrt = ref("");
const addHighLight = (selectedValue: any): void => {
  highLightTargrt.value = selectedValue;
  setTimeout(() => {
    highLightTargrt.value = "";
  }, 1000);
};

// 数量入力--------------------------------------------------
let holdQuantity = 0;
const focusQuantity = (e: any, index: number) => {
  holdQuantity = Number(e.target.value);
  syosiList.value[index].quantity = "";
};
const blurQuantity = (e: any, index: number) => {
  if (e.target.value === "") {
    syosiList.value[index].quantity = holdQuantity;
  }
  holdQuantity = 0;
};
const inputQuantity = (e: string | number, index: number) => {
  // 後ほどinputのバリデーション追加
  // if(typeof e === "string" && !e.match(/^[1-9][0-9]*$/g)){
  //   console.log("当てはまる");
  //   e.replace(/\D/g, "");
  //   items.value[index].quantity = 0
  //   console.log(items.value[index]);

  // } else {
  //   items.value[index].quantity = Number(e)
  // }

  //符号無し整数を判定
  if (!String(e).match(/^[0-9]+$/)) {
    syosiList.value[index].quantity = 0;
  } else {
    syosiList.value[index].quantity = Number(e);
  }
};

// ヘッダ情報の削除----------------------
const deleteHeader = () => {
  if (confirm("書店・取次情報を削除してもよろしいですか？")) {
    headerInfo.syotenMei = "";
    headerInfo.syotenCd = "";
    headerInfo.toritugiSyotenCd = "";
    headerInfo.toritugiCd = "";
    headerInfo.bansen = "";
    headerInfo.tanzaku = "";
    headerInfo.chumonRemarks = "";
    headerInfo.salesName = "";
    headerInfo.companyRemarks = "";
    headerInfo.torihikiCd = "1";
    headerInfo.torihikiKikan = "1";
  }
};

//カートの削除---------------------------
// 個別削除
const deleteItem = async (item: any, itemIndex: number) => {
  if (confirm(`「${item.title}」の注文を削除してもよろしいですか？`)) {
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/deleteChumonId`,
        [item.juchuCartId],
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      await getCartData();
      // 全ての明細が空だったら1件明細を追加する
      if (syosiList.value.length === 0 && addedMeisai.value.length === 0) {
        setInitialMeisai();
      }
    } catch (error) {
      alert("削除に失敗しました");
      console.log(error);
    }
  }
};
// 一括削除
const deleteAllItems = async () => {
  if (confirm(`全ての注文を削除してもよろしいですか？`)) {
    syosiList.value.splice(0, syosiList.value.length);
    addedMeisai.value.splice(0);
    try {
      await axios.delete(
        `${store.getters["getBaseUrl"]}/chumon/deleteNormalChumonAll`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setInitialMeisai();
    } catch (error) {
      alert("削除に失敗しました");
      console.log(error);
    }
  }
};
// 選択削除
const deleteSelectedItems = async () => {
  if (confirm(`選択された注文を削除してもよろしいですか？`)) {
    // 追加明細の削除
    addedMeisai.value = addedMeisai.value.filter((meisai) => !meisai.selectFlg);
    // 登録済み書誌の削除
    let postData: number[] = [];
    syosiList.value.forEach((syosi) => {
      if (syosi.selectFlg) postData.push(syosi.juchuCartId);
    });
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/deleteChumonId`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      await getCartData();
      if (syosiList.value.length === 0 && addedMeisai.value.length === 0) {
        setInitialMeisai();
      }
    } catch (error) {
      alert("削除に失敗しました");
      console.log(error);
    }
  }
};
// 選択削除のボタンdisabled制御用
const isShowSelectedDeleteBtn = computed(() => {
  let hasSelected = false;
  syosiList.value.forEach((syosi) => {
    if (syosi.selectFlg) hasSelected = true;
  });
  addedMeisai.value.forEach((meisai) => {
    if (meisai.selectFlg) hasSelected = true;
  });
  return hasSelected;
});
//書店モーダル関連---------------------------
watch(headerInfo, () => {
  store.commit("search/setSyotenDetailState", headerInfo);
});
//プロパティごとに代入するとリアクティブが効くが、丸ごと代入は利かない
const ref_selectSyoten = (selectedValue: any) => {
  // console.log(selectedValue);
  headerInfo.syotenMei = selectedValue.syotenMei;
  headerInfo.syotenCd = selectedValue.syotenCd;
  headerInfo.toritugiCd = selectedValue.toritugiCd;
  headerInfo.toritugiSyotenCd = selectedValue.toritugiSyotenCd;
  headerInfo.bansen = selectedValue.bansen;
  modalName.value = "";
};
const searchSyoten = async (value: string): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (headerInfo.toritugiSyotenCd === "") {
    headerInfo.syotenMei = "";
    // headerInfo.toritugiCd = "";
    headerInfo.syotenCd = "";
    headerInfo.toritugiSyotenCd = "";
    headerInfo.bansen = "";
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];
    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
    } else {
      // //該当する書店が無ければ以前の状態に戻す
      // headerInfo.toritugiSyotenCd = holdToritugiSyotenCd;

      // 該当する書店がなければ手入力の値を適用(取次コード・取次書店コード以外はリセットする)
      headerInfo.syotenMei = "";
      headerInfo.syotenCd = "";
      headerInfo.bansen = "";
      headerInfo.toritugiSyotenCd = value;
      notyf.error("該当する書店がありません");
    }
  }
  holdToritugiSyotenCd = "";
};
// 入力された取次書店CDを一時的に保持しておく
let holdToritugiSyotenCd = "";
const focusToritugiSyotenCd = (value: string) => {
  holdToritugiSyotenCd = value;
};
const inputToritugiSyotenCd = (value: string) => {
  headerInfo.toritugiSyotenCd = value;
  // //書店名と番線/作業コードをクリア
  // if (headerInfo.syotenMei !== "" || headerInfo.bansen !== "") {
  //   headerInfo.syotenMei = "";
  //   headerInfo.bansen = "";
  // }
};

//取次
const toritugiList: {
  toritugiCd: string;
  torihikisakiCd: string;
  toritugiMei: string;
}[] = [...store.getters["constant/getToritugiList"]];
// 初期値を空白にするためデータを代入
const hasInitialToritugi = toritugiList.find(
  (list: { toritugiCd: string; torihikisakiCd: string; toritugiMei: string }) =>
    list.toritugiCd === ""
);
if (hasInitialToritugi === undefined) {
  toritugiList.unshift({ toritugiCd: "", torihikisakiCd: "", toritugiMei: "" });
}

const inputToritugi = (e?: Event) => {
  if (!e) {
    headerInfo.toritugiCd = "";
  } else {
    headerInfo.toritugiCd = (e.target as HTMLInputElement).value;
    if (
      headerInfo.syotenMei !== "" ||
      headerInfo.bansen !== "" ||
      headerInfo.syotenCd !== "" ||
      headerInfo.toritugiSyotenCd !== ""
    ) {
      headerInfo.syotenMei = "";
      headerInfo.bansen = "";
      headerInfo.syotenCd = "";
      headerInfo.toritugiSyotenCd = "";
    }
  }
};
inputToritugi();

// 書店名入力時
const inputSyotenMei = (e: string) => {
  headerInfo.syotenMei = e;
};

// 番線入力時
const inputBansen = (e: string) => {
  headerInfo.bansen = e;
};
//バリデーション---------------------------
const isValidKikan = computed(() => {
  let pattern = /^([0-9]{0,2})$/;
  return headerInfo.torihikiKikan.match(pattern);
});
const isValidTanzaku = computed(() => {
  if (
    headerInfo.tanzaku.length &&
    (headerInfo.tanzaku.length > 16 || !isZenkaku(headerInfo.tanzaku))
  ) {
    return true;
  } else {
    return false;
  }
});
const isValidChumonRemarks = computed(() => {
  if (
    headerInfo.chumonRemarks.length &&
    (headerInfo.chumonRemarks.length > 30 ||
      !isZenkaku(headerInfo.chumonRemarks))
  ) {
    return true;
  } else {
    return false;
  }
});

const isZenkaku = (value: string) => {
  // eslint-disable-next-line no-control-regex
  const pattern = /^[^\x01-\x7E\uFF61-\uFF9F]+$/;
  return value.match(pattern);
};

// 登録ボタンクリック-----------
const registerCart = async () => {
  // エラーバリデーション
  if (
    headerInfo.syotenMei === "" ||
    headerInfo.toritugiSyotenCd === "" ||
    headerInfo.toritugiCd === ""
  ) {
    notyf.error({
      duration: 3000,
      message: "書店コードと書店名を入力してください",
    });
    return;
  }
  if (validMeisaiQuantity()) {
    notyf.error({ duration: 3000, message: "数量を入力してください" });
    return;
  }
  // 書誌情報が空の場合列を削除する
  validEmptyMeisaiSyosi();
  let noQuantity = false;
  syosiList.value.forEach((item) => {
    if (
      item.quantity === "" ||
      item.quantity === null ||
      Number(item.quantity) === 0
    ) {
      noQuantity = true;
    }
  });
  if (noQuantity) {
    notyf.error({ duration: 3000, message: "数量を入力してください" });
    return;
  } else if (
    isValidTanzaku.value ||
    isValidChumonRemarks.value ||
    ((headerInfo.torihikiCd == "2" || headerInfo.torihikiCd == "3") &&
      !isValidKikan.value)
  ) {
    notyf.error({
      duration: 3000,
      message: "書店・取次情報入力のエラーメッセージを確認してください",
    });
    return;
  }
  // 登録処理
  let isConfirm = window.confirm("登録してもよろしいですか？");
  if (isConfirm) {
    let postDataArray = [] as PostObj[];
    syosiList.value.forEach((item) => {
      let postObj = {} as PostObj;
      postObj.janCd = item.janCd;
      postObj.quantity = Number(item.quantity);
      postObj.hold = item.hold ? item.hold : false;
      postObj.juchuKbn = item.juchuKbn ? Number(item.juchuKbn) : null;
      postObj.tanzaku = headerInfo.tanzaku;
      postObj.chumonRemarks = headerInfo.chumonRemarks;
      postObj.companyRemarks = headerInfo.companyRemarks;
      postObj.zaikoStatus = Number(item.zsId);
      postObj.addNumber = item.addNumber;
      postDataArray.push(postObj);
    });
    addedMeisai.value.forEach((item, index) => {
      let postObj = {} as PostObj;
      postObj.janCd = item.janCd;
      postObj.quantity = Number(item.quantity);
      postObj.hold = item.hold ? item.hold : false;
      postObj.juchuKbn = item.juchuKbn ? Number(item.juchuKbn) : null;
      postObj.tanzaku = headerInfo.tanzaku;
      postObj.chumonRemarks = headerInfo.chumonRemarks;
      postObj.companyRemarks = headerInfo.companyRemarks;
      postObj.zaikoStatus = Number(item.zsId);
      postObj.addNumber = syosiList.value.length + index + 1;
      postDataArray.push(postObj);
    });
    const postData = {
      toritugiSyotenCd: headerInfo.toritugiSyotenCd,
      syotenCd: headerInfo.syotenCd,
      syotenMei: headerInfo.syotenMei,
      bansen: headerInfo.bansen,
      toritugiCd: headerInfo.toritugiCd,
      torihikiCd: Number(headerInfo.torihikiCd),
      salesName: headerInfo.salesName,
      normalJuchuDetails: postDataArray,
    };

    try {
      const res = await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/registerNormalChumon`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (res.status === 200) {
        notyf.success("受注登録が完了しました");
        addedMeisai.value.splice(0);
        // 9/15 確認モーダル廃止（念のためコードは残す）
        // modalName.value = "modalConfirmCustom";
        returnToOrderSearch();
      } else {
        notyf.error("受注登録に失敗しました");
      }
    } catch (e) {
      console.log(e);
    }
  }
};
// 登録完了後の画面遷移（モーダルから選択）
const returnToOrderSearch = () => {
  router.push("/orderSearch");
};
const reloadWindow = () => {
  location.reload();
};
//一時保存--------
let temporaryCart = ref([]);
let warningMessage = ref("");
let isClickedSaveCart = false;
const confirmSaveCart = () => {
  if (!syosiList.value.length && !addedMeisai.value.length) {
    notyf.error("カート未登録のため、一時保存が出来ません。");
    return;
  }

  //既に一時保存情報があったら一時保存カートが削除される
  if (temporaryCartNum.value) {
    isClickedSaveCart = true;
    warningMessage.value = `実行すると、現在登録されている${temporaryCartNum.value}件の一時保存情報が削除されます。\n一時保存後は通常入力画面に戻ります。\n実行してもよろしいですか？`;
    showModal("modalWarningMessage");
  } else {
    saveCart();
  }
};

const saveCart = async () => {
  // 書誌情報が空の場合列を削除する
  validEmptyMeisaiSyosi();
  temporaryCart.value.splice(0);

  let postSyosiList = syosiList.value.map((obj) =>
    Object.assign({}, obj)
  ) as any;
  const postAddedMeisaiList = addedMeisai.value.map((obj) =>
    Object.assign({}, obj)
  );
  postAddedMeisaiList.forEach((meisai: AddedMeisai) => {
    postSyosiList.push(meisai);
  });
  // ヘッダー情報を配列に格納する
  postSyosiList.forEach((syosi: any, index: number) => {
    syosi.bansen = headerInfo.bansen;
    syosi.chumonRemarks = headerInfo.chumonRemarks;
    syosi.companyRemarks = headerInfo.companyRemarks;
    syosi.salesName = headerInfo.salesName;
    syosi.syotenMei = headerInfo.syotenMei;
    syosi.tanzaku = headerInfo.tanzaku;
    syosi.torihikiCd = headerInfo.torihikiCd;
    syosi.torihikiKikan = headerInfo.torihikiKikan;
    syosi.toritugiCd = headerInfo.toritugiCd;
    syosi.toritugiSyotenCd = headerInfo.toritugiSyotenCd;
    syosi.addNumber = index + 1;
  });

  try {
    await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/temporary`,
      postSyosiList,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("一時保存しました");
    router.push("/orderSearch");
    addedMeisai.value.splice(0);
    getCartData();
    getTemporaryCartNum();
  } catch (error) {
    alert("一時保存に失敗しました");
    console.log(error);
  }
};
//復元-----
const confirmRestoreCart = () => {
  if (temporaryCartNum.value === 0) {
    notyf.error("一時保存中のデータが無いため、復元できません。");
    return;
  }
  //既に一時保存情報があったら一時保存カートが削除される
  if (syosiList.value.length) {
    warningMessage.value = `実行すると、現在登録されている${syosiList.value.length}件のカート情報が削除されます。\n実行してもよろしいですか？`;
    showModal("modalWarningMessage");
    isClickedSaveCart = false;
  } else {
    restoreCart();
  }
};
const restoreCart = async () => {
  try {
    await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/restore/temporary`,
      "",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("復元しました");

    getCartData();
    getTemporaryCartNum();
  } catch (error) {
    alert("復元に失敗しました");
    console.log(error);
  }
};
//一時保存or復元の実行
const save_restore_cart = () => {
  if (isClickedSaveCart) {
    saveCart();
  } else {
    restoreCart();
  }
};
//一時保存データ数取得--
let temporaryCartNum = ref<number>(0);
const getTemporaryCartNum = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/chumon/temporary`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    temporaryCartNum.value = res.data;
  } catch (error) {
    alert("一時保存データの取得に失敗しました");
    console.log(error);
  }
};
getTemporaryCartNum();
//アップロード処理--------
const inputFile = ref();
const onClick = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
};
const uploadFile = (e: any) => {
  const FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    // ブラウザからのファイルリード結果を変数に保存
    let DATA = e.target.result;
    let arr = fixdata(DATA);
    let wb;
    wb = xlsx.read(btoa(arr), {
      type: "base64",
      cellDates: true,
    });
    let JSON: { [anyKey: string]: any } = {};
    JSON = file_to_json(wb);

    //ファイルバリデーション
    if (hasFileError(JSON)) {
      notyf.error("フォーマットが異なっているためアップロード出来ません");
      return;
    }

    //コード区分・商品コード・数量のキーを書き換え
    const sheetName = Object.keys(JSON)[0];
    JSON = JSON[sheetName].map((e: { [x: string]: any }) => ({
      orderKbn: e["コード区分"],
      janCd: e["商品コード"],
      quantity: e["数量"],
    }));

    try {
      const res = await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/cartAddByCsv`,
        JSON,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (res.status === 200) {
        // notyf.success("受注登録が完了しました");
        //カート再取得
        getCartData();
      } else {
        notyf.error("アップロードに失敗しました");
        //カート再取得
        getCartData();
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 500) {
        notyf.error({
          duration: 10000,
          message: error.response?.data.userMessage,
        });
      } else {
        notyf.error("アップロードに失敗しました");
      }
      console.log(error);
      //カート再取得
      getCartData();
    }
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};

//EXCELファイルの読み込み
const fixdata = (DATA: any) => {
  let o = "",
    l = 0,
    w = 10240;
  for (; l < DATA.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(DATA.slice(l * w, l * w + w)) as any
    );
  o += String.fromCharCode.apply(
    null,
    new Uint8Array(DATA.slice(l * w)) as any
  );
  return o;
};

//読み込んだファイルをJSONへ変換
// ワークブックのデータをjsonに変換
const file_to_json = (workbook: xlsx.WorkBook) => {
  var result: { [anyKey: string]: any } = {};
  workbook.SheetNames.forEach(function (sheetName: string | number) {
    var roa = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], {
      raw: true,
    });
    if (roa.length > 0) {
      result[sheetName] = roa;
    }
  });
  return result;
};

const hasFileError = (JSON: { [anyKey: string]: any }) => {
  const sheetName = Object.keys(JSON)[0];
  if (!JSON[sheetName]) {
    return true;
  }

  //シートにデータが無ければ中断
  const firstFileJSON = JSON[sheetName];
  if (!firstFileJSON.length) {
    return true;
  }

  //シートのヘッダが「コード区分・商品コード・数量」でないものは中断
  let hasError = false;
  firstFileJSON.forEach((row: any) => {
    Object.keys(row).forEach((key) => {
      if (key !== "コード区分" && key !== "商品コード" && key !== "数量") {
        hasError = true;
      }
    });
  });
  return hasError;
};
// ソート関連----------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
  }
  sortInfo.value.sortItem = sortItem;

  getCartData();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};
// 一括設定関連------------------
// 全選択
let isActiveSelectAll = ref(false);
let selectAll = (selectFlg: boolean) => {
  isActiveSelectAll.value = selectFlg;
  syosiList.value.forEach((result): void => {
    if (selectFlg) {
      result.selectFlg = true;
    } else {
      result.selectFlg = false;
    }
  });
  addedMeisai.value.forEach((result): void => {
    if (selectFlg) {
      result.selectFlg = true;
    } else {
      result.selectFlg = false;
    }
  });
};
// フッターの数量が変更された場合
let updateNum = (orderNum: number): void => {
  syosiList.value.forEach((result): void => {
    if (result.selectFlg) {
      result.quantity = orderNum;
    }
  });
  addedMeisai.value.forEach((result): void => {
    if (result.selectFlg) {
      result.quantity = orderNum;
    }
  });
};

// 合計表示関連-----------------
const totalItem = computed(
  () => syosiList.value.length + addedMeisai.value.length
);
const totalNumber = computed(() => {
  let total = 0;
  syosiList.value.forEach((syosi) => {
    total += Number(syosi.quantity);
  });
  addedMeisai.value.forEach((meisai) => {
    total += Number(meisai.quantity);
  });
  return total;
});

// 追加明細関連----------------------------------------------
// 追加明細データ
const addedMeisai = ref([
  {
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: "" as number | string,
    juchuKbn: null as string | null,
    hontaiPrice: null as number | null,
    hold: false,
    availableAmount: null as number | null, // 出荷可能数
    torioki: null as number | null, // 取置数
    inputSum: null as number | null, // 受注合計
    holdSum: null as number | null, // 保留合計
    zsId: "" as string | null, // 在庫ID
    zsName: "" as string | null, // 在庫ステータス
    syuppanSyosiCd: "",
    selectFlg: false,
  },
]);
const addLineNumList = [1, 5, 10, 30, 50];
const selectedLineNum = ref(1);
const addNormalOrderList = () => {
  for (let i = 0; i < selectedLineNum.value; i++) {
    addedMeisai.value.push({
      janCd: "",
      syosiCd: "",
      title: "",
      quantity: "",
      juchuKbn: null,
      hontaiPrice: null,
      hold: false,
      availableAmount: null,
      torioki: null,
      inputSum: null,
      holdSum: null,
      zsId: "",
      zsName: "",
      syuppanSyosiCd: "",
      selectFlg: false,
    });
  }
};
// データがない場合に1件明細を追加する
const setInitialMeisai = () => {
  addedMeisai.value.push({
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: "",
    juchuKbn: null,
    hontaiPrice: null,
    hold: false,
    availableAmount: null,
    torioki: null,
    inputSum: null,
    holdSum: null,
    zsId: "",
    zsName: "",
    syuppanSyosiCd: "",
    selectFlg: false,
  });
};

// 書誌検索モーダル-----------
const syosiModalVisible = ref(false); // 表示制御フラグ
let changeSyosiTarget = ref({} as AddedMeisai);
// 直接コード入力されたとき↓↓
const focusSyosiCd = (event: any, orderIndex: number) => {
  changeSyosiTarget.value = addedMeisai.value[orderIndex];
};
const searchSyosi = async (event: any): Promise<void> => {
  if (event.target.value === "") {
    return;
  } else {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi?&syosiCd=${event.target.value}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data.syosiList.length > 0) {
      ref_selectSyosi(res.data.syosiList[0]);
    }
    event.target.value = "";
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyosiModal = (orderIndex: number) => {
  changeSyosiTarget.value = addedMeisai.value[orderIndex];
  syosiModalVisible.value = true;
};
const ref_selectSyosi = (selectedValue: ZaikoData) => {
  changeSyosiTarget.value.janCd = selectedValue.janCd;
  changeSyosiTarget.value.syosiCd = selectedValue.syosiCd;
  changeSyosiTarget.value.title = selectedValue.title;
  changeSyosiTarget.value.hontaiPrice = selectedValue.hontaiPrice;
  changeSyosiTarget.value.availableAmount = selectedValue.availableAmount;
  changeSyosiTarget.value.torioki = selectedValue.torioki;
  changeSyosiTarget.value.inputSum = selectedValue.inputSum;
  changeSyosiTarget.value.holdSum = selectedValue.holdSum;
  changeSyosiTarget.value.zsId = selectedValue.zsId;
  changeSyosiTarget.value.zsName = selectedValue.zsName;
  changeSyosiTarget.value.syuppanSyosiCd = selectedValue.syuppanSyosiCd;
};
// 入力関連--------------
// 数量
let holdMeisaiQuantity = 0;
const focusMeisaiQuantity = (e: any, index: number) => {
  holdMeisaiQuantity = Number(e.target.value);
  addedMeisai.value[index].quantity = "";
};
const blurMeisaiQuantity = (e: any, index: number) => {
  if (e.target.value === "") {
    addedMeisai.value[index].quantity = holdMeisaiQuantity;
  }
  holdMeisaiQuantity = 0;
};
const inputMeisaiQuantity = (e: string | number, index: number) => {
  //符号無し整数を判定
  if (!String(e).match(/^[0-9]+$/)) {
    addedMeisai.value[index].quantity = 0;
  } else {
    addedMeisai.value[index].quantity = Number(e);
  }
};
// 明細削除
const deleteMeisaiItem = async (item: any, itemIndex: number) => {
  if (confirm(`「${item.title}」の注文を削除してもよろしいですか？`)) {
    addedMeisai.value.splice(itemIndex, 1);
    if (syosiList.value.length === 0 && addedMeisai.value.length === 0) {
      setInitialMeisai();
    }
  }
};
// カート保存(ページ遷移時)----
const saveMeisai = async () => {
  // バリデーション
  if (validMeisaiQuantity()) {
    notyf.error({ duration: 3000, message: "数量を入力してください" });
    return "error";
  }
  // 登録処理
  else {
    try {
      // 書誌情報が空の場合列を削除する
      validEmptyMeisaiSyosi();
      let cartItem: { janCd: string | null; quantity: number }[] = [];
      addedMeisai.value.forEach((meisai) => {
        cartItem.push({
          janCd: meisai.janCd,
          quantity: Number(meisai.quantity),
        });
      });
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/cartAddNormalChumon`,
        cartItem,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success(`カートに製品を追加しました`);
      return "success";
    } catch (error) {
      console.log(error);
      notyf.error("カートの保存に失敗しました");
      return "error";
    }
  }
};

// バリデーション関連----------
// 書誌情報が空の場合削除
const validEmptyMeisaiSyosi = () => {
  let deleteIndex: number[] = [];
  addedMeisai.value.forEach((meisai, index) => {
    if (meisai.janCd === "") deleteIndex.push(index);
  });
  addedMeisai.value = addedMeisai.value.filter((value, index) => {
    return deleteIndex.indexOf(index) === -1;
  });
};
// 数量
const validMeisaiQuantity = () => {
  let hasError = false;
  addedMeisai.value.forEach((meisai) => {
    if (
      meisai.janCd !== "" &&
      (Number(meisai.quantity) === 0 || meisai.quantity === "")
    )
      hasError = true;
  });
  return hasError;
};

// エンターキーでの移動用--------------------------------
const { creatMoveWithEnterElms, moveNext, movePrev } = common();
let moveWithEnterElms = ref([] as HTMLElement[]);
watch([syosiList.value, addedMeisai.value], async () => {
  moveWithEnterElms.value = await creatMoveWithEnterElms();
});

// キークリック関連------------------------
const onKeyDown = (e: any) => {
  // console.log(e);
  if (e.key === "Enter" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
    moveNext(e, moveWithEnterElms.value);
  } else if (e.key === "Enter" && !e.altKey && !e.ctrlKey && e.shiftKey) {
    movePrev(e, moveWithEnterElms.value);
  } else if (e.key === "F8" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
    setTimeout(() => {
      registerCart();
    }, 100);
  }
};
onMounted(() => {
  document.addEventListener("keydown", onKeyDown);
});
onBeforeUnmount(() => {
  document.removeEventListener("keydown", onKeyDown);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CartNormal", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    (_unref(modalName) === 'modalShop')
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 0,
          toritugiCd: _unref(headerInfo).toritugiCd,
          onClose: closeModal,
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    (syosiModalVisible.value)
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (syosiModalVisible.value = false)),
          onRef_selectSyosi: ref_selectSyosi
        }))
      : _createCommentVNode("", true),
    (_unref(modalName) === 'modalOrderUploadTutorial')
      ? (_openBlock(), _createBlock(ModalOrderUploadTutorial, {
          key: 2,
          onClose: closeModal
        }))
      : _createCommentVNode("", true),
    (_unref(modalName) === 'modalWarningMessage')
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 3,
          onClose: closeModal,
          onExecute: save_restore_cart,
          message: _unref(warningMessage)
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(modalName) === 'modalConfirm')
      ? (_openBlock(), _createBlock(ModalConfirm, {
          key: 4,
          message: '追加明細データをカートに保存しますか？',
          onExecute: excuteSaveMeisai,
          onClose: closeModal
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("select", {
                    class: "Move_With_Enter",
                    onChange: inputToritugi,
                    value: _unref(headerInfo).toritugiCd
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                      return _createElementVNode("option", {
                        value: option.toritugiCd,
                        key: index
                      }, _toDisplayString(option.toritugiMei), 9, _hoisted_11)
                    }), 64))
                  ], 40, _hoisted_10)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Yellow Move_With_Enter",
                    onDblclick: _cache[1] || (_cache[1] = ($event: any) => (showModal('modalShop'))),
                    type: 'text',
                    value: _unref(headerInfo).toritugiSyotenCd,
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (focusToritugiSyotenCd(_unref(headerInfo).toritugiSyotenCd))),
                    onOnInput: inputToritugiSyotenCd,
                    onOnChange: searchSyoten,
                    onkeydown: "return event.keyCode !== 69"
                  }, null, 8, ["value"]),
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Medium",
                    onOnInput: inputSyotenMei,
                    value: _unref(headerInfo).syotenMei
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Medium Move_With_Enter",
                    onOnInput: inputBansen,
                    value: _unref(headerInfo).bansen
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(headerInfo).torihikiCd) = $event)),
                    class: "CartNormal_ListContent_Select Move_With_Enter"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(torihikiList), (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: option.torihikiCd,
                        key: index
                      }, _toDisplayString(option.torihikiMei), 9, _hoisted_24))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(headerInfo).torihikiCd]
                  ])
                ])
              ]),
              (
                  _unref(headerInfo).torihikiCd == '2' || _unref(headerInfo).torihikiCd == '3'
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(headerInfo).torihikiKikan) = $event)),
                        class: "CartNormal_ListContent_Input"
                      }, null, 512), [
                        [_vModelText, _unref(headerInfo).torihikiKikan]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!isValidKikan.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, " ※「期間」は1~99の半角数字で入力してください "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Large Move_With_Enter",
                    value: _unref(headerInfo).tanzaku,
                    onOnInput: _cache[5] || (_cache[5] = ($event: any) => (inputHederInfo($event, 'tanzaku')))
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            (isValidTanzaku.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, _hoisted_36))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Large Move_With_Enter",
                    value: _unref(headerInfo).chumonRemarks,
                    onOnInput: _cache[6] || (_cache[6] = ($event: any) => (inputHederInfo($event, 'chumonRemarks')))
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            (isValidChumonRemarks.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_41, _hoisted_43))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("select", {
                    class: "Move_With_Enter",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(headerInfo).salesName) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesList), (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: option.salesCd,
                        key: index
                      }, _toDisplayString(option.salesName), 9, _hoisted_48))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(headerInfo).salesName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(InputText, {
                    class: "CartNormal_Input_Large Move_With_Enter",
                    value: _unref(headerInfo).companyRemarks,
                    onOnInput: _cache[8] || (_cache[8] = ($event: any) => (inputHederInfo($event, 'companyRemarks')))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(BtnGreenSmall, {
              onClick: deleteHeader,
              class: "Move_With_Enter"
            }, {
              default: _withCtx(() => [
                _createTextVNode("取次情報削除")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createVNode(selectBarSingle, {
            selectBarList_props: _unref(selectBar_syubetu),
            onUpdateSelectValue: updateSelectSyubetu
          }, null, 8, ["selectBarList_props"]),
          _createVNode(selectBarSingle, {
            selectBarList_props: _unref(selectBar_hold),
            onUpdateSelectValue: updateSelectHold
          }, null, 8, ["selectBarList_props"])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createVNode(BtnGreenSmall, {
              onClick: confirmSaveCart,
              class: _normalizeClass(["Move_With_Enter", { BtnGray: !_unref(syosiList).length && !addedMeisai.value.length }])
            }, {
              default: _withCtx(() => [
                _createTextVNode("一時保存")
              ]),
              _: 1
            }, 8, ["class"]),
            (_unref(temporaryCartNum) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_unref(temporaryCartNum)), 1))
              : _createCommentVNode("", true),
            _createVNode(BtnGreenSmall, {
              class: _normalizeClass(["Move_With_Enter", { BtnGray: _unref(temporaryCartNum) <= 0 }]),
              onClick: confirmRestoreCart
            }, {
              default: _withCtx(() => [
                _createTextVNode("復元")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("input", {
              onChange: uploadFile,
              onClick: resetFile,
              type: "file",
              ref_key: "inputFile",
              ref: inputFile,
              accept: ".xlsx",
              style: {"display":"none"}
            }, null, 544),
            _createVNode(_component_font_awesome_icon, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (showModal('modalOrderUploadTutorial'))),
              icon: "info-circle",
              class: "CartNormal_InfoButton",
              style: {"margin-right":"5px"}
            }),
            _createVNode(BtnGreenSmall, {
              class: "Move_With_Enter",
              onClick: onClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("アップロード")
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_61, [
            _createVNode(BtnGreenSmall, {
              onClick: deleteSelectedItems,
              class: _normalizeClass({
                BtnGray: !isShowSelectedDeleteBtn.value,
                Move_With_Enter: isShowSelectedDeleteBtn.value,
              }),
              disabled: !isShowSelectedDeleteBtn.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("選択削除")
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            _createVNode(BtnGreenSmall, {
              class: "Move_With_Enter",
              onClick: deleteAllItems
            }, {
              default: _withCtx(() => [
                _createTextVNode("すべて削除")
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _unref(syosiList).length || addedMeisai.value.length]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        (_unref(syosiList).length || addedMeisai.value.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_63, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (header, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: _normalizeClass(["CartNormal_FrameTable_Tate CartNormal_FrameTable_minW_s", {
                  CartNormal_FrameTable_Sticky_TH: header.stickyFlg,
                  th_sort: header.sortFlg,
                }])
                    }, [
                      (!header.titleB)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            onClick: ($event: any) => (
                    header.sortFlg && header.dataTitle
                      ? sortTable(header.dataTitle)
                      : ''
                  )
                          }, [
                            _createElementVNode("span", null, _toDisplayString(showSortSymbol(header.dataTitle as string)), 1),
                            _createTextVNode(_toDisplayString(header.title), 1)
                          ], 8, _hoisted_64))
                        : _createCommentVNode("", true),
                      (header.titleB)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("p", {
                              onClick: ($event: any) => (
                      header.sortFlg && header.dataTitle
                        ? sortTable(header.dataTitle)
                        : ''
                    )
                            }, [
                              _createElementVNode("span", null, _toDisplayString(showSortSymbol(header.dataTitle as string)), 1),
                              _createTextVNode(_toDisplayString(header.title), 1)
                            ], 8, _hoisted_66),
                            _createElementVNode("p", {
                              onClick: ($event: any) => (
                      header.sortFlg && header.dataTitleB
                        ? sortTable(header.dataTitleB)
                        : ''
                    )
                            }, [
                              _createElementVNode("span", null, _toDisplayString(showSortSymbol(header.dataTitleB as string)), 1),
                              _createTextVNode(_toDisplayString(header.titleB), 1)
                            ], 8, _hoisted_67),
                            _createElementVNode("p", {
                              onClick: ($event: any) => (
                      header.sortFlg && header.dataTitleC
                        ? sortTable(header.dataTitleC)
                        : ''
                    )
                            }, [
                              _createElementVNode("span", null, _toDisplayString(showSortSymbol(header.dataTitleC as string)), 1),
                              _createTextVNode(_toDisplayString(header.titleC), 1)
                            ], 8, _hoisted_68)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syosiList), (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_69, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", _hoisted_70, [
                      _withDirectives(_createElementVNode("input", {
                        class: "Move_With_Enter",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((item.selectFlg) = $event),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_71), [
                        [_vModelCheckbox, item.selectFlg]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_72, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(item.syosiCd) + " ", 1),
                        (item.hold)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                              _createVNode(BadgeHold)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_74,
                        _createTextVNode(_toDisplayString(item.syuppanSyosiCd) + " ", 1),
                        _hoisted_75,
                        _createTextVNode(_toDisplayString(item.janCd), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_76, [
                      _createElementVNode("div", null, _toDisplayString(item.title), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.hontaiPrice) + "円", 1),
                    _createElementVNode("td", _hoisted_77, [
                      _createVNode(InputText, {
                        value: item.quantity,
                        type: 'number',
                        onFocus: ($event: any) => (focusQuantity($event, index)),
                        onOnInput: ($event: any) => (inputQuantity($event, index)),
                        onBlur: ($event: any) => (blurQuantity($event, index)),
                        class: "CartNormal_Input_Small Move_With_Enter"
                      }, null, 8, ["value", "onFocus", "onOnInput", "onBlur"])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) == 'syubetu' })
                    }, [
                      _createElementVNode("select", {
                        value: item.juchuKbn,
                        onChange: ($event: any) => (selecSyosiInfo($event, index, 'juchuKbn')),
                        class: _normalizeClass(["Move_With_Enter", {
                    selectHighLight: _unref(highLightTargrt) == 'syubetu',
                  }])
                      }, _hoisted_82, 42, _hoisted_78)
                    ], 2),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) === 'hold' })
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "Move_With_Enter",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((item.hold) = $event),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_83), [
                        [_vModelCheckbox, item.hold]
                      ])
                    ], 2),
                    _createElementVNode("td", null, _toDisplayString(item.availableAmount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.zsName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.torioki), 1),
                    _createElementVNode("td", null, _toDisplayString(item.inputSum), 1),
                    _createElementVNode("td", null, _toDisplayString(item.holdSum), 1),
                    _createElementVNode("td", _hoisted_84, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "CartNormal_FrameTable_Icon Move_With_Enter",
                        icon: "trash-can",
                        tabindex: "0",
                        onClick: ($event: any) => (deleteItem(item, index)),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (deleteItem(item, index)), ["exact","prevent"]), ["space"])
                      }, null, 8, ["onClick", "onKeydown"])
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addedMeisai.value, (meisai, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_85, _toDisplayString(_unref(syosiList).length + index + 1), 1),
                    _createElementVNode("td", _hoisted_86, [
                      _withDirectives(_createElementVNode("input", {
                        class: "Move_With_Enter",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((meisai.selectFlg) = $event),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_87), [
                        [_vModelCheckbox, meisai.selectFlg]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_88, [
                      _createElementVNode("input", {
                        class: "CartNormal_FrameTable_Inputdblclick Move_With_Enter",
                        type: "text",
                        placeholder: "商品コード",
                        onDblclick: ($event: any) => (openSearchSyosiModal(index)),
                        onFocus: ($event: any) => (focusSyosiCd($event, index)),
                        onChange: searchSyosi
                      }, null, 40, _hoisted_89),
                      _createTextVNode(" " + _toDisplayString(meisai.syosiCd), 1),
                      _hoisted_90,
                      _createTextVNode(" " + _toDisplayString(meisai.syuppanSyosiCd), 1),
                      _hoisted_91,
                      _createTextVNode(" " + _toDisplayString(meisai.janCd) + " ", 1),
                      (meisai.hold)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                            _createVNode(BadgeHold)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_93, [
                      _createElementVNode("div", null, _toDisplayString(meisai.title), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (meisai.hontaiPrice !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(meisai.hontaiPrice) + "円", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_95, [
                      _createVNode(InputText, {
                        value: meisai.quantity,
                        type: 'number',
                        onFocus: ($event: any) => (focusMeisaiQuantity($event, index)),
                        onOnInput: ($event: any) => (inputMeisaiQuantity($event, index)),
                        onBlur: ($event: any) => (blurMeisaiQuantity($event, index)),
                        class: "CartNormal_Input_Small Move_With_Enter"
                      }, null, 8, ["value", "onFocus", "onOnInput", "onBlur"])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) == 'syubetu' })
                    }, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((meisai.juchuKbn) = $event),
                        class: _normalizeClass(["Move_With_Enter", {
                    selectHighLight: _unref(highLightTargrt) == 'syubetu',
                  }])
                      }, _hoisted_100, 10, _hoisted_96), [
                        [_vModelSelect, meisai.juchuKbn]
                      ])
                    ], 2),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) === 'hold' })
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "Move_With_Enter",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((meisai.hold) = $event),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_101), [
                        [_vModelCheckbox, meisai.hold]
                      ])
                    ], 2),
                    _createElementVNode("td", null, _toDisplayString(meisai.availableAmount), 1),
                    _createElementVNode("td", null, _toDisplayString(meisai.zsName), 1),
                    _createElementVNode("td", null, _toDisplayString(meisai.torioki), 1),
                    _createElementVNode("td", null, _toDisplayString(meisai.inputSum), 1),
                    _createElementVNode("td", null, _toDisplayString(meisai.holdSum), 1),
                    _createElementVNode("td", _hoisted_102, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "CartNormal_FrameTable_Icon Move_With_Enter",
                        icon: "trash-can",
                        tabindex: "0",
                        onClick: ($event: any) => (deleteMeisaiItem(meisai, index)),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (deleteMeisaiItem(meisai, index)), ["exact","prevent"]), ["space"])
                      }, null, 8, ["onClick", "onKeydown"])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_103, null, 512), [
        [_vShow, _unref(syosiList).length || addedMeisai.value.length]
      ])
    ]),
    (!_unref(syosiList).length && !addedMeisai.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      class: "Move_With_Enter",
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedLineNum).value = $event))
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(addLineNumList, (line, index) => {
        return _createElementVNode("option", {
          value: line,
          key: index
        }, _toDisplayString(line), 9, _hoisted_107)
      }), 64))
    ], 512), [
      [_vModelSelect, selectedLineNum.value]
    ]),
    _createTextVNode("行 "),
    _createElementVNode("button", {
      onClick: addNormalOrderList,
      class: "CartNormal_Button GreenRev Move_With_Enter"
    }, " + 明細追加 "),
    (_unref(syosiList).length || addedMeisai.value.length)
      ? (_openBlock(), _createBlock(OrderFooter, {
          key: 6,
          isActive_SidebarFlg: props.isActive_SidebarFlg,
          fromCartNormal: true,
          totalItem: totalItem.value,
          totalNumber: totalNumber.value,
          onAddCart: registerCart,
          onChange: _unref(selectAll),
          onUpdateNum: _unref(updateNum)
        }, null, 8, ["isActive_SidebarFlg", "totalItem", "totalNumber", "onChange", "onUpdateNum"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})